import * as fr from '@angular/common/locales/fr';
import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';

import { AuthenticationService } from './authentication/services/authentification.service';
import { User_info_auth } from './authentication/models/user_info';
import { AlertComponent } from './components/alert/alert.component';
import { CopyrightComponent } from './components/copyright/copyright.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { HeaderComponent } from './components/header/header.component';
import { NgIf, NgClass, registerLocaleData } from '@angular/common';
import { DOCUMENT } from '@angular/common';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['./app.component.css'],
    imports: [NgIf, HeaderComponent, SidebarComponent, CopyrightComponent, NgClass, AlertComponent, RouterOutlet]
})
export class AppComponent {
    currentUser: User_info_auth;
    title = 'Sigelam front'

    constructor(
        private router: Router,
        private authenticationService: AuthenticationService
    ) {
        this.authenticationService.currentUser.subscribe(x => {
            this.currentUser = x;
        });
        registerLocaleData(fr.default);
    }


}
